export default __webpack_public_path__ + "static/pic01-3a2d92db446cb3a46e8954e27b8798a8.jpg";